import Swiper, { Lazy, Autoplay, EffectFade } from 'swiper'

Swiper.use([ Lazy, Autoplay, EffectFade ]);

export default {
    sliderHome() {
        const elem = $('.hero-home').find('.swiper-container')
        if(elem.length) {

            const sliderHome = new Swiper(elem[0], {
                speed: 1000,
                spaceBetween: 0,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                lazy: {
                    loadPrevNext: true,
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                touchRatio: 0,
                // navigation: {
                //     nextEl: '.arrow-right',
                //     prevEl: '.arrow-left',
                // },
                loop: true,
                // pagination: {
                //     el: '.home-slider-pagination',
                //     type: 'bullets',
                //     clickable: true,
                // },
            })

        }
    },

    visionSlider() {
        const elem = $('.vision-slider')
        if(elem.length) {

            const sliderHome = new Swiper(elem.find('.swiper-container')[0], {
                speed: 1000,
                spaceBetween: 0,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: elem.find('.arrow-right')[0],
                    prevEl: elem.find('.arrow-left')[0],
                },
            })

        }
    },
    init() {
        this.sliderHome()
        this.visionSlider()
    },
}
